import type { EventAuthOnLogOut } from 'src/core/events/EventTypes';
import TypedEventEmitter from 'src/core/events/TypedEventEmitter';
import type Constants from 'src/core/utils/Constants';

type AuthEventMap = Record<typeof Constants.eventAuthOnLogOut, EventAuthOnLogOut>;

export const authEventBus = new TypedEventEmitter<AuthEventMap>();
